import React from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../common/icon';

const SubscriptionsActions = ({ subscription, performAction }) => {
  const canStart = subscription.availableActions.includes('unpause');
  const canPause = subscription.availableActions.includes('pause');
  const canCancel = subscription.availableActions.includes('cancel');

  return (
    <div data-automation-id={`membership-subscription-actions-${subscription.id}`}>
      <Icon
        data-automation-id="action-start"
        glyph={GLYPHS.membershipsStart}
        className="u-mr u-cursor-pointer"
        display-if={canStart}
        onClick={() => performAction(subscription, 'unpause')}
      />
      <Icon
        data-automation-id="action-pause"
        glyph={GLYPHS.membershipsPause}
        className="u-mr u-cursor-pointer"
        display-if={canPause}
        onClick={() => performAction(subscription, 'pause')}
      />
      <Icon
        data-automation-id="action-cancel"
        glyph={GLYPHS.membershipsCancel}
        className="u-cursor-pointer"
        display-if={canCancel}
        onClick={() => performAction(subscription, 'cancel')}
      />
    </div>
  );
};

SubscriptionsActions.propTypes = {
  performAction: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
};

export default SubscriptionsActions;
